<template>
  <div v-if="params.value !== undefined" class="ag-table-cell-value-wrapper">
    <div class="ag-table-cell-value ag-table-accruals-sum-renderer"
         :title="commentTitle"
    >
      <div class="ag-table-accruals-sum-renderer__sum">
        {{value}}
      </div>
      <div v-if="!!params.data.formula"
           title="Как был произведен расчет"
           class="ag-table-accruals-sum-renderer__icon link-icon"
           @click="onClick"
      >
        <app-icon name="InfoIcon2" size="16px"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  export default  Vue.extend({
    name: "AccrualsSumRenderer",
    computed: {
      value(){
        return this.params.value;
      },
      commentTitle(){
        return this.params.branch_comment || "";
      }
    },
    methods: {
      onClick(){
        this.params.onClick(this.params.data.id);
      }
    }
  });
</script>

<style lang="scss">
.ag-table-accruals-sum-renderer{
  position: relative;

  &_can-show{

  }

  &__sum{
    display: inline-block;
    min-width: 80px;
  }

  &__icon{
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

  }
}
</style>